/**
 * @Description 收入分布
 */

import { FC, memo } from 'react';
import styles from './index.module.less';
import cs from 'classnames';
import V2BarChart from '@/common/components/Charts/V2BarChart';

// const mockIncomeData = [
//   { name: '10万及以下', value: 12 },
//   { name: '10-20万', value: 45 },
//   { name: '20-30万', value: 15 },
//   { name: '30-40万', value: 35 },
//   { name: '40-50万', value: 8 },
//   { name: '50-60万', value: 38 },
//   { name: '60-70万', value: 18 },
//   { name: '70-80万', value: 28 }
// ];
const IncomeDistributionRatio: FC<{
  data: any[];
}> = ({
  data,
}) => {
  return (
    <div className={cs(styles.chartWrapper, styles.pieChart, 'pd-16')}>
      <div className='fs-14 c-222 bold'>收入分布</div>
      <V2BarChart
        title=''
        resizable={false}
        direction='horizontal'
        xAxisData={data?.map((item) => item.name) || []}
        seriesData={[{
          data: data,
          unit: '%',
          animation: false,
        }]}
        height={264}
        config={{
          legend: {
            show: false
          },
          grid: {
            left: 80,
            top: 16,
            right: 16,
            bottom: 24,
          },
          yAxis: {
            axisLabel: {
              formatter: '{value}%'
            },
          },
        }}
      />
    </div>
  );
};

export default memo(IncomeDistributionRatio);
